import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=e9629680&"
import script from "./SP.vue?vue&type=script&lang=js&"
export * from "./SP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9629680')) {
      api.createRecord('e9629680', component.options)
    } else {
      api.reload('e9629680', component.options)
    }
    module.hot.accept("./SP.vue?vue&type=template&id=e9629680&", function () {
      api.rerender('e9629680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/SP.vue"
export default component.exports